// Assets/custom-animations.js
(function() {
  const initAnimations = () => {
    const sections = document.querySelectorAll('.reveal-on-scroll');
    
    sections.forEach(section => {
      const textElement = section.querySelector('.rich-text__text');
      
      // Split text logic
      if (textElement && !textElement.dataset.splitDone) {
        textElement.innerHTML = textElement.innerHTML.trim().split(/<br\s*\/?>/i).map((line, i) => {
          return `<span class="line-mask"><span class="line-item" style="transition-delay: ${0.3 + (i * 0.1)}s!important">${line.trim()}</span></span>`;
        }).join('');
        textElement.dataset.splitDone = "true";
      }

      // Intersection Observer logic
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            section.classList.add('content-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      observer.observe(section);
    });
  };

  document.addEventListener('DOMContentLoaded', initAnimations);
  document.addEventListener('shopify:section:load', initAnimations);
  initAnimations();
})();